<div #canvasContainer id="ManipClickableContainer">
    <canvas #canvas class="ManipClickableCanvas"></canvas>
    <ng-content></ng-content>
</div>